import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const MemberTagsPageComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "MemberTagsPage" */ "@circle-react/components/SettingsApp/MemberTags"
    ),
);

export const MemberTagsPage = () => (
  <Suspense fallback={<PageLoader />}>
    <MemberTagsPageComponent />
  </Suspense>
);
